import { useEffect, useState } from 'react';
import { useT } from '../i18n/LangProvider';

// Sep 15 2026, 09:00 ET. EDT = UTC-4 → 13:00 UTC.
const TARGET = new Date('2026-09-15T13:00:00Z').getTime();

function diff() {
  const ms = TARGET - Date.now();
  if (ms <= 0) return null;
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms % 86400000) / 3600000),
    minutes: Math.floor((ms % 3600000) / 60000),
    seconds: Math.floor((ms % 60000) / 1000)
  };
}

export default function Countdown() {
  const { t } = useT();
  const [time, setTime] = useState(diff());

  useEffect(() => {
    const id = setInterval(() => setTime(diff()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!time) {
    return <div className="font-display text-2xl text-brand-red">{t('hero.live')}</div>;
  }

  const cells = [
    { v: time.days, l: t('hero.cdDays') },
    { v: time.hours, l: t('hero.cdHours') },
    { v: time.minutes, l: t('hero.cdMinutes') },
    { v: time.seconds, l: t('hero.cdSeconds') }
  ];

  return (
    <div>
      <p className="text-[10px] tracking-[0.25em] uppercase text-ink-muted font-mono mb-3">{t('hero.countdownLabel')}</p>
      <div className="flex gap-3 md:gap-4">
        {cells.map((c, i) => (
          <div key={i} className="flex flex-col items-center">
            <div className="min-w-[58px] md:min-w-[76px] px-2 py-3 rounded-xl border border-white/[0.1] bg-white/[0.03] backdrop-blur-sm text-center">
              <span className="font-display text-3xl md:text-4xl tabular-nums text-ink">{String(c.v).padStart(2, '0')}</span>
            </div>
            <span className="text-[11px] uppercase tracking-wider text-ink mt-2 font-mono font-medium">{c.l}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
